<template>
    <div class="context_menu_separator"></div>
</template>

<script>
export default {
    name: 'ContextMenuSeparator'
}
</script>

<style scoped>
.context_menu_separator {
    margin-block: 0.25rem;
    height: 1px;
    background-color: rgb(72, 72, 72);
}
</style>
